module.exports = __webpack_public_path__ + "img/default.15381f95.png";